// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"k4-z","button":"l4-z","disabled":"m4-z","creditCard":"n4-z","wrapper":"o4-z"};